export default {"src":"https://images-cdn.curipod.com/d-3562c6ac/_next/static/media/stars.e76db6a2.svg","height":270,"width":249};